<template>
  <div>
    <div class="ui form" style="margin-bottom: 30px;">
      <div class="required two fields">
        <div class="field">
          <label for="purchasedDate">From Date</label>
          <div style="text-align: center" class="ui calendar" :id="'from-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'From Date'"
                     readonly=""
                     name="formDate">
            </div>
          </div>
        </div>
        <div class="field">
          <label for="purchasedDate">To Date</label>
          <div style="text-align: center" class="ui calendar" :id="'to-date'">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text"
                     :placeholder="'To Date'"
                     readonly=""
                     name="toDate">
            </div>
          </div>
        </div>
      </div>
      <div class="ui blue right floated submit button"
           style="background-color: #092442"
           @click="getReports()">
        Submit
      </div>
    </div>
    <br>
    <div class="ui divider"></div>
    <br>
    <div v-if="loading" class="ui active centered inline loader">
      <div class="ui text loader">{{ $t('loading') }}...</div>
    </div>
    <div v-else>
      <div class="ui fluid tabular menu">
        <a class="item" :class="{ active: currentTab === tabs.first }"
          @click="currentTab = tabs.first">
          All transactions
        </a>
        <a class="item" :class="{ active: currentTab === tabs.second }"
          @click="currentTab = tabs.second">
          Patient transactions
        </a>
      </div>
      <div class="ui grid" style="padding-bottom: 50px">
        <div class="sixteen wide column" style="margin-top: 30px">
          <allTransactions 
            :transactions="transactions"
            v-if="currentTab === tabs.first" 
          />
          <patientTransactions
            :transactions="transactions"
            :reservationTransactions="reservationTransactions"
            :reservations="reservations"
            v-if="currentTab === tabs.second" 
          />
        </div>
      </div>
    </div>
  </div>  
</template>

<script>
export default {
  components: {
    abstractTable: require('@/components/abstract_components/AbstractTable')
      .default,
    allTransactions: require('./daily_transactions_component/AllTransactions').default,
    patientTransactions: require('./daily_transactions_component/PatientTransactions').default,
  },
  data() {
    const tabs = {
      first: 'All transactions',
      second: 'Patient tranasactions'
    }
    return {
      from_date: window.moment().startOf('day').toString(),
      to_date: window.moment().endOf('day').toString(),
      tabs: tabs,
      currentTab: tabs.first,
      selectedClinicId: null,
      transactions: [],
      reservations: [],
      reservationTransactions: [],
      loading: true
    }
  },
  watch: {
    currentTab(newValue, oldValue) {
      this.transactions = []
      this.reservations = []
      this.reservationTransactions = []
      this.getReports()
    }
  },
  computed: {
    useInventory() {
      return this.permissions.invetory_permissions.used
    },
  },
  mounted () {
    this.selectedClinicId = this.getFromLocalStorage('clinicId')
    this.getAllTransactions()
  },
  methods: {
    getReports() {
      if (this.currentTab === this.tabs.first) {
        this.getAllTransactions()
      } else {
        this.getPatientTransactions()
      }
    },
    getAllTransactions () {
      this.loading = true
      this.$http.get('financial/reports', {
        params: {
          clinic_id: this.selectedClinicId,
          from_date: this.from_date,
          to_date: this.to_date
        }
      }).then(response => {
        this.transactions = response.data.meta
        this.initGUI()
        this.loading = false
      })
    },
    getPatientTransactions() {
      this.loading = true
      this.$http.get('patients/transactions', {
        params: {
          clinic_id: this.selectedClinicId,
          from_date: this.from_date,
          to_date: this.to_date
        }
      }).then(response => {
        this.transactions = response.data.meta.transactions
        this.reservations = response.data.reservations
        this.reservationTransactions = response.data.meta.reservation_transactions
        this.initGUI()
        this.loading = false
      })
    },
    initGUI() {
      this.$nextTick(() => {
        $('#from-date').calendar({
          type: this.useInventory ? 'datetime' : 'date',
          onChange: (date) => {
            this.from_date = date
          }
        })

        $(`#from-date`).calendar(
          'set date',
          this.from_date
        )

        $('#to-date').calendar({
          type: this.useInventory ? 'datetime' : 'date',
          onChange: (date) => {
            this.to_date = date
          }
        })
        
        $(`#to-date`).calendar(
          'set date',
          this.to_date
        )
      })
    }
  },
}
</script>

<style scoped>
.centered-header {
  display: flex !important;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/financial_system/DailyTransactionReport.vue